import { ElementType, ReactNode } from "react";
import { Controller } from "react-hook-form";
import { Input } from "@chakra-ui/react";
import { ChakraProps } from "@chakra-ui/system/dist/types/system.types";

import { FieldPrototype } from "./FieldPrototype";
import { TextFieldType } from "./types/TextFieldType";
import { InputProps } from "@chakra-ui/input/dist/types/input";

export interface ITextFieldProps extends InputProps {
  name: string;
  label?: ReactNode;
  isRequired?: boolean;
  type?: TextFieldType;
  containerProps?: ChakraProps;
  as?: ElementType;
}

const TextField = ({
  isRequired = true,
  label,
  name,
  type = TextFieldType.TEXT,
  containerProps,
  ...restProps
}: ITextFieldProps) => {
  return (
    <FieldPrototype
      isRequired={isRequired}
      label={label}
      name={name}
      {...containerProps}
    >
      {({
        hasError,
        methods: {
          formState: { isSubmitting },
        },
      }) => (
        <Controller
          name={name}
          render={(props) => (
            <Input
              id={`${name}-text-field`}
              autoComplete="on"
              type={type}
              isInvalid={hasError}
              disabled={isSubmitting}
              {...props}
              {...restProps}
            />
          )}
        />
      )}
    </FieldPrototype>
  );
};

export { TextField };
